import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FlaskConical } from "lucide-react";
import { api } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { fmtMT } from "@/lib/mountainTime";

export const getTestMode = () => api.get("/test-mode").then((r) => r.data);
export const setTestMode = (enabled) => api.put("/test-mode", { enabled }).then((r) => r.data);
export const setTestFlag = (id, isTest) => api.post(`/applications/${id}/test-flag`, { is_test: isTest }).then((r) => r.data);

export function TestBadge({ testId }) {
  return <span data-testid={testId} className="inline-flex items-center rounded bg-fuchsia-600 text-white text-[10px] font-extrabold tracking-wider px-1.5 py-0.5">TEST</span>;
}

export function TestModeBanner() {
  const [on, setOn] = useState(false);
  useEffect(() => { getTestMode().then((m) => setOn(m.enabled)).catch(() => {}); }, []);
  if (!on) return null;
  return (
    <div data-testid="test-mode-banner" className="bg-fuchsia-700 text-white text-xs font-bold tracking-wide text-center py-1.5 px-3 flex items-center justify-center gap-2">
      <FlaskConical className="h-3.5 w-3.5" /> TEST MODE ON — TEST records can be deleted with their signed TEST agreements. New applications stay LIVE unless TEST is chosen
    </div>
  );
}

export function TestModeCard() {
  const [m, setM] = useState(null);
  useEffect(() => { getTestMode().then(setM).catch(() => {}); }, []);
  if (!m) return null;
  const toggle = async (v) => {
    try { setM(await setTestMode(v)); toast.success(v ? "Test Mode ON" : "Test Mode OFF"); }
    catch { toast.error("Could not change Test Mode"); }
  };
  return (
    <section data-testid="test-mode-card" className={`rounded-xl border p-4 sm:p-5 ${m.enabled ? "border-fuchsia-300 bg-fuchsia-50" : "border-stone-200 bg-white"}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="font-semibold text-stone-900 flex items-center gap-2"><FlaskConical className="h-4 w-4 text-fuchsia-700" /> Development / Test Mode</h2>
          <p className="mt-1 text-sm text-stone-600">New applications and invitations are <strong>LIVE</strong> unless TEST is explicitly chosen (Pipeline TEST view, or <code>/apply/…?env=test</code> while signed in as an admin or TEST account). While ON, TEST applications can be permanently deleted from the Applications dashboard, including signed TEST agreements. Real signed agreements always stay protected.</p>
          {m.updated_by && <p className="mt-1 text-[11px] text-stone-400">Last changed by {m.updated_by} · {fmtMT(m.updated_at)}</p>}
        </div>
        <Switch data-testid="test-mode-switch" checked={m.enabled} disabled={!m.can_change} title={m.can_change ? undefined : "Only the platform super admin can change Test Mode"} onCheckedChange={toggle} aria-label="Test Mode" />
      </div>
    </section>
  );
}
